import { useTheme } from '@mui/material';
const useInfoCardStyles = () => {
    const theme = useTheme();
    return {
        infoCardStyles: {
            display: 'flex',
            border: `1px solid ${theme.palette.action.active}`,
            flexDirection: 'column',
            width: '100%',
            py: 2,
            px: 3,
            borderRadius: 1.5,
            boxShadow: theme.customShadows.card,
            gap: 1.5,
            position: 'relative',
            svg: {
                position: 'absolute',
                top: 0,
                right: 0
            },
            img: {
                position: 'absolute',
                top: 0,
                right: 0,
                width: 114,
                height: 114
            }
        }
    };
};
export default useInfoCardStyles;
